import GenericTable from "../../components/common/genericTable";

import './style.scss';

export const route = '/tabledemo';

const Tabledemo = () => {
  const tableData = {
    basic: [
      {atp_code: "000923", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {atp_code: "000924", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {atp_code: "000925", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {atp_code: "000926", school_name: "Dewey HS", city: "Oakland", batch_type: "A"}
    ],
    visuallyBlankColumn: [
      {checkbox: "-", atp_code: "000923", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {checkbox: "-", atp_code: "000924", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {checkbox: "-", atp_code: "000925", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
      {checkbox: "-", atp_code: "000926", school_name: "Dewey HS", city: "Oakland", batch_type: "A"}
    ],
    emptyColumn: [
    {empty_field: "", atp_code: "000923", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
    {empty_field: "", atp_code: "000924", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
    {empty_field: "", atp_code: "000925", school_name: "Dewey HS", city: "Oakland", batch_type: "A"},
    {empty_field: "", atp_code: "000926", school_name: "Dewey HS", city: "Oakland", batch_type: "A"}
  ],
    colspan: [
    {atp_code: "000923", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000924", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000925", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000926", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"}
  ],
    rowspan: [
    {atp_code: "000923", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000924", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000925", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"},
    {atp_code: "000926", school_name: "Dewey HS", address: "Oakland CA, 98765", batch_type: "A"}
  ],
  };

  const cols = {
    basic: [
      {name: 'atp_code', label: 'ATP Code'},
      {name: 'school_name', label: 'School Name'},
      {name: 'city', label: 'City'},
      {name: 'batch_type', label: 'Batch Type'}
    ],
    visuallyBlankColumn: [
      {name: 'checkbox', label: 'Visually Blank', hideLabel: true},
      {name: 'atp_code', label: 'ATP Code'},
      {name: 'school_name', label: 'School Name'},
      {name: 'city', label: 'City'},
      {name: 'batch_type', label: 'Batch Type'}
    ],
    emptyColumn: [
      {name: 'empty_field', label: ''},
      {name: 'atp_code', label: 'ATP Code'},
      {name: 'school_name', label: 'School Name'},
      {name: 'city', label: 'City'},
      {name: 'batch_type', label: 'Batch Type'}
    ],
    rowScope: [
      {name: 'atp_code', label: 'ATP Code', scope: 'row'},
      {name: 'school_name', label: 'School Name', scope: 'col'},
      {name: 'city', label: 'City', scope: 'col'},
      {name: 'batch_type', label: 'Batch Type', scope: 'col'}
    ],
    colspan: [
      {name: 'atp_code', label: 'ATP Code'},
      {name: 'school_name', label: 'School Name'},
      {name: 'address', label: 'Address', colspan: '3'},
      {name: 'batch_type', label: 'Batch Type'}
    ],
    rowspan: [
      {name: 'atp_code', label: 'ATP Code', 'rowspan': 2},
      {name: 'school_name', label: 'School Name'},
      {name: 'address', label: 'Address'},
      {name: 'batch_type', label: 'Batch Type'}
    ],
  }

  return (
    <main className='main-content full-width-section'>
      <h1>Standard Table</h1>
      <GenericTable tableData={tableData.basic} cols={cols.basic}/>
      <br /><br />
      <h1>Table w/ Visually Blank Header Column</h1>
      <GenericTable tableData={tableData.visuallyBlankColumn} cols={cols.visuallyBlankColumn}/>
      <br /><br />
      <h1>Table w/ Empty Header Column</h1>
      <GenericTable tableData={tableData.emptyColumn} cols={cols.emptyColumn}/>
      <br /><br />
      <h1>Table w/ Row Header Column (i.e. uses row scope)</h1>
      <GenericTable tableData={tableData.basic} cols={cols.rowScope}/>
      <br /><br />
      <h1>Table w/ a Header that uses colspan)</h1>
      <GenericTable tableData={tableData.colspan} cols={cols.colspan}/>
      <br /><br />
      <h1>Table w/ a Header that uses rowspan)</h1>
      <GenericTable tableData={tableData.rowspan} cols={cols.rowspan}/>

    </main>
  );
}

export default Tabledemo;